
import { Component, Vue } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import Util from '@/lib/util';
import Tiptop from '@/components/headers/tiptop.vue';
import LanguageList from '@/components/language-list.vue';
import HeaderCommon from './header-common.vue';
import breadcrumbNav from '@/components/breadcrumb-nav.vue';
import AppConsts from '@/lib/appConst';

@Component({
  components: { Tiptop, LanguageList, HeaderCommon, breadcrumbNav },
  props: {
    hideBreadcrumb: Boolean
  }
})
export default class Header extends AbpBase {
  left: number = 0;
  currentMenuId: string = '';

  get isStandardEdition() {
    return Util.isStandardEdition();
  }

  get navData() {
    return this.$store.state.productCategory.list;
  }

  created() {
    this.getNavData();
  }

  mounted() {
    this.left = this.getLeft();
    window.onresize = () => {
      this.left = this.getLeft();
    };
  }

  getNavData() {
    this.$store.dispatch({
      type: 'productCategory/getNavigationList',
      data: null
    });
  }

  getLeft() {
    let clientWidth = document.body.clientWidth;
    let left = 0;

    if (clientWidth > 1200) {
      left = (clientWidth - 1200) / 2;
    }

    if (this.$route.name === "default" && left > 10) {
      left -= 9;
    }

    return left;
  }

  handleMouseEnterMenu(e) {
    this.currentMenuId = e.target.dataset.id;
  }

  handleMouseLeaveMenu(e) {
    this.currentMenuId = '';
  }
}
